import types from './types'

const createCollapseAction = (type) => (isCollapsed) => {
  return (dispatch) => {
    dispatch({
      type,
      payload: isCollapsed,
    })
  }
}

const updateCollapseAcademicOverview = createCollapseAction(types.UPDATE_COLLAPSE_ACADEMIC_OVERVIEW)
const updateCollapseApplicationStatus = createCollapseAction(types.UPDATE_COLLAPSE_APPLICATION_STATUS)
const updateCollapseScattergram = createCollapseAction(types.UPDATE_COLLAPSE_SCATTERGRAM)
const updateCollapseChecklist = createCollapseAction(types.UPDATE_COLLAPSE_CHECKLIST)
const updateCollapseDocumentStatus = createCollapseAction(types.UPDATE_COLLAPSE_DOCUMENT_STATUS)
const updateCollapseHistory = createCollapseAction(types.UPDATE_COLLAPSE_PROSPECT_HISTORY)

export default {
  updateCollapseAcademicOverview,
  updateCollapseApplicationStatus,
  updateCollapseChecklist,
  updateCollapseDocumentStatus,
  updateCollapseScattergram,
  updateCollapseHistory,
}
